module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1.thumbnails.biosphere.exchange.uncertainty.f1b47dd2.png").toString();